<template>
  <mu-container>
    <mu-paper :z-depth="1" class="w-100 p-20">
      <mu-flex justify-content="center">
        <h1>Witaj w panelu Dropshippingu, co chcesz zrobić?</h1>
      </mu-flex>
      <mu-flex justify-content="center">
        <mu-row>
          <mu-col span="5">
            <mu-button to="/dashboard/order/add" full-width>
              <mu-icon left value="add_shopping_cart"></mu-icon>
              dodaj zamówienie
            </mu-button>
          </mu-col>
          <mu-col offset="2" span="5">
            <mu-button to="/dashboard/order/earnings" full-width>
              <mu-icon left value="euro_symbol"></mu-icon>
              twój zysk
            </mu-button>
            <mu-button to="/dashboard/order/history" full-width>
              <mu-icon left value="history"></mu-icon>
              historia zamówień
            </mu-button>
            <mu-button
              href="http://eromed.pl/pl/content/28-zasady-wspolpracy-dropshipping"
              target="_blank"
              full-width
            >
              <mu-icon left value="assignment"></mu-icon>
              zasady współpracy
            </mu-button>
          </mu-col>
        </mu-row>
      </mu-flex>
    </mu-paper>
  </mu-container>
</template>

<script>
export default {
  name: "Dashboard"
};
</script>
